import {createSlice} from "@reduxjs/toolkit";

interface IInitState {
    isAlertOpen: boolean
    doctorCount:number|null
    feedbackCount:number|null
    reconciliationsCount:number|null
    appointmentCount:number|null
    monthDataCount:number|null

}

const initialState: IInitState = {
    isAlertOpen: false,
    doctorCount:null,
    feedbackCount:null,
    reconciliationsCount:null,
    appointmentCount:null,
    monthDataCount:null,
}

const calendarReducer = createSlice({
    name: 'calendar',
    reducers: {
        setAlertOpen: (state, {payload}) => {
            state.isAlertOpen = payload
        },
        setDoctorCount: (state, {payload}) => {
            state.doctorCount = payload
        },
        setFeedbackCount: (state, {payload}) => {
            state.feedbackCount = payload
        },
        setReconciliationsCount: (state, {payload}) => {
            state.reconciliationsCount = payload
        },
        setAppointmentCount: (state, {payload}) => {
            state.appointmentCount = payload
        },
        setMonthDataCount: (state, {payload}) => {
            state.monthDataCount = payload
        },

    },
    initialState,

})

export const {setAlertOpen, setDoctorCount, setFeedbackCount, setReconciliationsCount,setAppointmentCount, setMonthDataCount} = calendarReducer.actions
export default calendarReducer.reducer
